import React from "react";
import { FlatList, StyleSheet } from "react-native";
import TabButton2 from "./TabButton2";

interface TabItem {
  btnTxt: string;
  key: string;
}

interface HorizontalTabProps {
  pickupTab: TabItem[];
  activeTab: string;
  setActiveTab: (key: string) => void;
}

const HorizontalTab: React.FC<HorizontalTabProps> = ({
  pickupTab,
  activeTab,
  setActiveTab,
}) => {
  return (
    <FlatList
      data={pickupTab}
      keyExtractor={(item) => item.key}
      renderItem={({ item }) => (
        <TabButton2
          title={item.btnTxt}
          isActive={item.key === activeTab}
          onPress={() => setActiveTab(item.key)}
        />
      )}
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.container}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 12,
  },
});

export default HorizontalTab;
